import { Flex, Text } from "@chakra-ui/react";
import { InfoIcon } from "@/styles/icons/InfoIcon";
import { formatCurrency } from "@/utils";

interface LimitUpdateAlertProps {
  sameOwnershipDayLimit?: number | null;
  sameOwnershipNightLimit?: number | null;
  otherOwnershipDayLimit?: number | null;
  otherOwnershipNightLimit?: number | null;
}

export function LimitUpdateAlert({
  sameOwnershipDayLimit,
  sameOwnershipNightLimit,
  otherOwnershipDayLimit,
  otherOwnershipNightLimit,
}: LimitUpdateAlertProps) {
  const formatLimit = (value: number | null | undefined) => {
    if (!value || value === 0) return "-";
    return formatCurrency({ value }).replace("R$", "").trim();
  };

  return (
    <Flex
      bg="#e1f6fd"
      border="1px solid #00749e"
      borderRadius="4px"
      p="14px"
      gap="8px"
      alignItems="center"
      w="100%"
    >
      <Flex
        bg="#a9daed"
        borderRadius="100px"
        w="22px"
        h="22px"
        alignItems="center"
        justifyContent="center"
        flexShrink={0}
      >
        <InfoIcon size={14} color="#00749e" />
      </Flex>
      <Flex
        flex="1"
        flexDir="column"
        gap="7px"
        alignItems="flex-start"
        justifyContent="center"
      >
        <Text
          fontSize="16px"
          fontWeight="600"
          color="#262626"
          lineHeight="normal"
        >
          Atualização do limite
        </Text>
        <Text
          fontSize="14px"
          fontWeight="400"
          color="#525252"
          lineHeight="normal"
        >
           
            A atualização dos limites ocorrerá em até 24 horas. Durante esse período, continuam valendo os limites atuais da conta:{" "}
          <Text as="span" fontWeight="700">
            {formatLimit(sameOwnershipDayLimit)}
          </Text>{" "}
          e{" "}
          <Text as="span" fontWeight="700">
            {formatLimit(sameOwnershipNightLimit)}
          </Text>{" "}
            para transações de mesma titularidade e{" "}
          <Text as="span" fontWeight="700">
            {formatLimit(otherOwnershipDayLimit)}
          </Text>{" "}
          e{" "}
          <Text as="span" fontWeight="700">
            {formatLimit(otherOwnershipNightLimit)}
          </Text>{" "}
            para outras titularidades.
        </Text>
      </Flex>
    </Flex>
  );
}

